var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVesselOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 34.1667,
    height: 34.1667,
    rx: 5.58333,
    fill: "#E8ECF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 34.1667,
    height: 34.1667,
    rx: 5.58333,
    stroke: "#E8ECF3",
    strokeWidth: 0.833333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8266 15.468L12.0016 29.293C11.7844 29.5102 11.526 29.6039 11.2998 29.5735C9.93362 29.3896 8.55597 28.6044 7.46322 27.4962C6.37 26.3876 5.61249 25.007 5.42904 23.6976C5.39769 23.4739 5.49013 23.2168 5.70778 22.9991L19.5328 9.17413C19.6974 9.0095 19.9101 8.9014 20.1401 8.86541L25.7585 7.98644C26.4945 7.8713 27.1295 8.50624 27.0143 9.24226L26.1353 14.8607C26.0994 15.0907 25.9913 15.3034 25.8266 15.468Z",
    fill: "#F0533E",
    stroke: "white",
    strokeWidth: 1.09914,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2278 14.5369C16.3933 14.3714 16.6073 14.263 16.8387 14.2276L20.0033 13.7431C20.7367 13.6309 21.3683 14.2625 21.2561 14.9959L20.7716 18.1605C20.7362 18.3919 20.6278 18.6059 20.4623 18.7714L11.7128 27.521C11.4797 27.754 11.1522 27.8785 10.8315 27.8024C9.09104 27.3889 7.46567 25.8084 7.16004 24.1258C7.10593 23.828 7.23132 23.5333 7.44538 23.3193L16.2278 14.5369Z",
    fill: "#C12B17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVesselOffline);
export default __webpack_public_path__ + "static/media/icon-vessel-offline.582e4f6f771aef40d0169b3f52b798a0.svg";
export { ForwardRef as ReactComponent };